import type { PrintingOptions } from '#api/tmsApiService'
import type { PrintOptions } from '#features/PrintOptions/PrintOptions'

export function convertPrintOptionsFromManCode(printOptions: PrintingOptions | undefined | null): PrintOptions | undefined {
  if (!printOptions) {
    return undefined
  }

  const converted: PrintOptions = {
    previewImage: false,
    emphasize: false,
    printDescription: false,
    doNotPrint: false,
    imageOverrides: {},
  }
  for (const printOption of printOptions) {
    switch (printOption) {
      case 'picture':
        converted.previewImage = true
        break
      case 'boldCode':
        converted.emphasize = true
        break
      case 'extendedDescription':
        converted.printDescription = true
        break
      case 'hidden':
        converted.doNotPrint = true
        break
    }
  }
  return converted
}

export function convertPrintOptionsToManCode(printOptions: PrintOptions | undefined | null): PrintingOptions | undefined {
  if (!printOptions) {
    return undefined
  }

  const converted: PrintingOptions = []
  if (printOptions.previewImage) {
    converted.push('picture')
  }
  if (printOptions.emphasize) {
    converted.push('boldCode')
  }
  if (printOptions.printDescription) {
    converted.push('extendedDescription')
  }
  if (printOptions.doNotPrint) {
    converted.push('hidden')
  }
  return converted
}
